import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_FORMATS, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { TreoAutogrowModule } from 'tsui/@treo';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { DirectivesModule } from '../../directives/directives.module';

import { CurrencyMaskModule } from 'ng2-currency-mask';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

import { ParcelMapComponent } from './parcel-map.component';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { FloodMapLegendComponent } from 'app/modules/research/@components/flood-map-legend/flood-map-legend.component';
import { TsCheckboxComponent } from 'tsui';

@NgModule({
  declarations: [ParcelMapComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TsCheckboxComponent,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    NgApexchartsModule,
    MatMenuModule,
    MatMomentDateModule,
    MatProgressBarModule,
    MatRippleModule,
    NgxMapboxGLModule,
    MatSelectModule,
    MatChipsModule,
    MatAutocompleteModule,
    TreoAutogrowModule,
    PipesModule,
    DirectivesModule,
    CurrencyMaskModule,
    FloodMapLegendComponent,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [ParcelMapComponent],
  providers: [provideNgxMask()],
})
export class ParcelMapModule {}
